export const actionTypes = {
  GET_PROJECT_MAINTENANCE_SUCCESS: 'GET_PROJECT_MAINTENANCE_SUCCESS',
  GET_PROJECT_MAINTENANCE_FIALURE: 'GET_PROJECT_MAINTENANCE_FIALURE',
  GET_PROJECT_MAINTENANCE__LOADER: 'GET_PROJECT_MAINTENANCE__LOADER',

  SEARCH_PROJECT_SUCCESS: 'SEARCH_PROJECT_SUCCESS',
  SEARCH_PROJECT_FAILURE: 'SEARCH_PROJECT_FAILURE',
  SEARCH_PROJECT_LOADER: 'SEARCH_PROJECT_LOADER',

  OPEN_PROJECT_SUCCESS: 'OPEN_PROJECT_SUCCESS',
  OPEN_PROJECT_FAILURE: 'OPEN_PROJECT_FAILURE',
  OPEN_PROJECT_LOADER: 'OPEN_PROJECT_LOADER',

  SET_DATA_PROJECT_MAINTENANCE: 'SET_DATA_PROJECT_MAINTENANCE',
  SET_INVOICE_CONTEXT: 'SET_INVOICE_CONTEXT',

  GET_RESOURCES_SUCCESS: 'GET_RESOURCES_SUCCESS',
  GET_RESOURCES_FAILURE: 'GET_RESOURCES_FAILURE',
  GET_RESOURCES_LOADER: 'GET_RESOURCES_LOADER',

  OPEN_INVOICE_CASE_SUCCESS: 'OPEN_INVOICE_CASE_SUCCESS',
  OPEN_INVOICE_CASE_FAILURE: 'OPEN_INVOICE_CASE_FAILURE',
  OPEN_INVOICE_CASE_LOADER: 'OPEN_INVOICE_CASE_LOADER',

  GET_INVOICE_DETAILS_SUCCESS: 'GET_INVOICE_DETAILS_SUCCESS',
  GET_INVOICE_DETAILS_FAILURE: 'GET_INVOICE_DETAILS_FAILURE',
  GET_INVOICE_DETAILS_LOADER: 'GET_INVOICE_DETAILS_LOADER',

  RESET_INVOICE_DATA: 'RESET_INVOICE_DATA',
  RESET_INVOICE_RESOURCE_DATA: 'RESET_INVOICE_RESOURCE_DATA',

  GET_fORM_BASICDATA_SUCCESS: 'GET_fORM_BASICDATA_SUCCESS',
  GET_fORM_BASICDATA_FAILURE: 'GET_fORM_BASICDATA_FAILURE',
  GET_fORM_BASICDATA_LOADER: 'GET_fORM_BASICDATA_LOADER',

  EDIT_PROJECT_SUCCESS: 'EDIT_PROJECT_SUCCESS',
  EDIT_PROJECT_FAILURE: 'EDIT_PROJECT_FAILURE',
  EDIT_PROJECT_LOADER: 'EDIT_PROJECT_LOADER',

  SAVE_SUCCESS: 'SAVE_SUCCESS',
  SAVE_FAILURE: 'SAVE_FAILURE',
  SAVE_LOADER: 'SAVE_LOADER',

  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  SUBMIT_FAILURE: 'SUBMIT_FAILURE',
  SUBMIT_LOADER: 'SUBMIT_LOADER',

  SAVE_INVOICE_SUCCESS: 'SAVE_INVOICE_SUCCESS',
  SAVE_INVOICE_FAILURE: 'SAVE_INVOICE_FAILURE',
  SAVE_INVOICE_LOADER: 'SAVE_INVOICE_LOADER',

  SUBMIT_INVOICE_SUCCESS: 'SUBMIT_INVOICE_SUCCESS',
  SUBMIT_INVOICE_FAILURE: 'SUBMIT_INVOICE_FAILURE',
  SUBMIT_INVOICE_LOADER: 'SUBMIT_INVOICE_LOADER',

  VOID_INVOICE_SUCCESS: 'VOID_INVOICE_SUCCESS',
  VOID_INVOICE_FAILURE: 'VOID_INVOICE_FAILURE',
  VOID_INVOICE_LOADER: 'VOID_INVOICE_LOADER',

  MANAGE_PROJECT_SUCCESS: 'MANAGE_PROJECT_SUCCESS',
  MANAGE_PROJECT_FAILURE: 'MANAGE_PROJECT_FAILURE',
  MANAGE_PROJECT_LOADER: 'MANAGE_PROJECT_LOADER',

  CLONE_PROJECT_SUCCESS: 'CLONE_PROJECT_SUCCESS',
  CLONE_PROJECT_FAILURE: 'CLONE_PROJECT_FAILURE',
  CLONE_PROJECT_LOADER: 'CLONE_PROJECT_LOADER',

  CLOSE_PROJECT_SUCCESS: 'CLOSE_PROJECT_SUCCESS',
  CLOSE_PROJECT_FAILURE: 'CLOSE_PROJECT_FAILURE',
  CLOSE_PROJECT_LOADER: 'CLOSE_PROJECT_LOADER',

  SET_DATA_CASE_AUTHENTICATION: 'SET_DATA_CASE_AUTHENTICATION',

  RESOURCE_NEED_CASE_SUCCESS: 'RESOURCE_NEED_CASE_SUCCESS',
  RESOURCE_NEED_CASE_FAILURE: 'RESOURCE_NEED_CASE_FAILURE',
  RESOURCE_NEED_CASE_LOADER: 'RESOURCE_NEED_CASE_LOADER',

  SEARCH_EMP_PROJECT_SUCCESS: 'SEARCH_EMP_PROJECT_SUCCESS',
  SEARCH_EMP_PROJECT_FAILURE: 'SEARCH_EMP_PROJECT_FAILURE',
  SEARCH_EMP_PROJECT_LOADER: 'SEARCH_EMP_PROJECT_LOADER',

  SUBMIT_SWAP_SUCCESS: 'SUBMIT_SWAP_SUCCESS',
  SUBMIT_SWAP_FAILURE: 'SUBMIT_SWAP_FAILURE',
  SUBMIT_SWAP_LOADER: 'SUBMIT_SWAP_LOADER',

  RESET_SWAP_DATA: 'RESET_SWAP_DATA',

  SWAP_CASE_DETAILS_SUCCESS: 'SWAP_CASE_DETAILS_SUCCESS',
  SWAP_CASE_DETAILS_FAILURE: 'SWAP_CASE_DETAILS_FAILURE',
  SWAP_CASE_DETAILS_LOADER: 'SWAP_CASE_DETAILS_LOADER',

  CLICK_APPLY_SUCCESS: 'CLICK_APPLY_SUCCESS',
  CLICK_APPLY_FAILURE: 'CLICK_APPLY_FAILURE',
  CLICK_APPLY_LOADER: 'CLICK_APPLY_LOADER',

  SUBMIT_PROJECT_UPDATE_SUCCESS: 'SUBMIT_PROJECT_UPDATE_SUCCESS',
  SUBMIT_PROJECT_UPDATE_FAILURE: 'SUBMIT_PROJECT_UPDATE_FAILURE',
  SUBMIT_PROJECT_UPDATE_LOADER: 'SUBMIT_PROJECT_UPDATE_LOADER',

  CLEAR_WARNING_MSG: 'CLEAR_WARNING_MSG',

  FETCH_RESUME_SUCCESS: 'FETCH_RESUME_SUCCESS',
  FETCH_RESUME_FAILURE: 'FETCH_RESUME_FAILURE',
  SHOW_RESUME_FETCH_LOADER: 'SHOW_RESUME_FETCH_LOADER',

  SHOW_SKILL_SUCCESS: 'SHOW_SKILL_SUCCESS',
  SHOW_SKILL_FAILURE: 'SHOW_SKILL_FAILURE',
  SHOW_SKILL_UPDATE_LOADER: 'SHOW_SKILL_UPDATE_LOADER',

  WITHDRAW_PM_CASE_SUCCESS: 'WITHDRAW_PM_CASE_SUCCESS',
  WITHDRAW_PM_CASE_FAILURE: 'WITHDRAW_PM_CASE_FAILURE',
  WITHDRAW_PM_CASE_LOADER: 'WITHDRAW_PM_CASE_LOADER',

  RETRY_PROJECT_SYNC_SUCCESS: 'RETRY_PROJECT_SYNC_SUCCESS',
  RETRY_PROJECT_SYNC_FAILURE: 'RETRY_PROJECT_SYNC_FAILURE',
  RETRY_PROJECT_SYNC_LOADER: 'RETRY_PROJECT_SYNC_LOADER',

  GET_AUDIT_HISTORY_SUCCESS: 'GET_AUDIT_HISTORY_SUCCESS',
  GET_AUDIT_HISTORY_FAILURE: 'GET_AUDIT_HISTORY_FAILURE',
  GET_AUDIT_HISTORY_LOADER: 'GET_AUDIT_HISTORY_LOADER',
  
  UPDATE_CLIENT_STATUS_SUCCESS: 'UPDATE_CLIENT_STATUS_SUCCESS',
  UPDATE_CLIENT_STATUS_FAILURE: 'UPDATE_CLIENT_STATUS_FAILURE',
  UPDATE_CLIENT_STATUS_LOADER: 'UPDATE_CLIENT_STATUS_LOADER',

  CHECK_INACTIVE_ELIGIBILITY_SUCCESS: 'CHECK_INACTIVE_ELIGIBILITY_SUCCESS',
  CHECK_INACTIVE_ELIGIBILITY_FAILURE: 'CHECK_INACTIVE_ELIGIBILITY_FAILURE',
  CHECK_INACTIVE_ELIGIBILITY_LOADER: 'CHECK_INACTIVE_ELIGIBILITY_LOADER',
};
